const arrowSvg = ({ fill = '#FFF'}) => {
  return (
<svg viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg">
<path id="&#231;&#174;&#173;&#233;&#160;&#173; 1" d="M10 12L0 2.71332L2.92173 0L10 6.57337L17.0783 0L20 2.71332L10 12Z" fill={fill}/>
</svg>
)
}
export default arrowSvg
